import React, { ComponentType } from "react";
import {
  Shuffle,
  GraduationCap,
  Disc3,
  HelpCircle,
  Gift,
  Hash,
  Utensils,
  Users,
  UsersRound,
  Handshake,
  Dices,
  CircleDollarSign,
  Timer,
  LayoutGrid,
  Sparkles,
  Type,
  BookA,
  ListChecks,
  CircleHelp,
  Palette,
  MessageCircleQuestion,
  Compass,
  UserRoundCheck,
  Split,
  ListOrdered,
  Trophy,
  ClipboardList,
  Lightbulb,
  Wind,
  Drama,
  Brush,
  Scale,
  Brain,
  Flame,
  FilePlus,
  Scissors,
  RotateCw,
  FileOutput,
  Trash2,
  Edit3,
  Droplets,
  Archive,
  SunMedium,
  Wrench,
  Image,
  FileText,
  Table,
  Presentation,
  Code,
  FileType,
  FileImage,
  FileCode,
  FileSpreadsheet,
  Lock,
  Unlock,
  PenTool,
  ScanText,
  QrCode,
} from "lucide-react";

const ICON_MAP: Record<string, ComponentType<{ className?: string }>> = {
  Shuffle,
  GraduationCap,
  Disc3,
  HelpCircle,
  Gift,
  Hash,
  Utensils,
  Users,
  UsersRound,
  Handshake,
  Dices,
  CircleDollarSign,
  Timer,
  LayoutGrid,
  Sparkles,
  Type,
  BookA,
  ListChecks,
  CircleHelp,
  Palette,
  MessageCircleQuestion,
  Compass,
  UserRoundCheck,
  Split,
  ListOrdered,
  Trophy,
  ClipboardList,
  Lightbulb,
  Wind,
  Drama,
  Brush,
  Scale,
  Brain,
  Flame,
  FilePlus,
  Scissors,
  RotateCw,
  FileOutput,
  Trash2,
  Edit3,
  Droplets,
  Archive,
  SunMedium,
  Wrench,
  Image,
  FileText,
  Table,
  Presentation,
  Code,
  FileType,
  FileSpreadsheet,
  Spreadsheet: FileSpreadsheet,
  FileLines: FileText,
  Lock,
  Unlock,
  PenTool,
  ScanText,
  QrCode,
};

export function ToolIcon({ name, className }: { name: string; className?: string }) {
  const IconComponent = ICON_MAP[name] || FileText;
  return <IconComponent className={className} />;
}

export function PdfToolIcon({ name, className }: { name: string; className?: string }) {
  const IconComponent = ICON_MAP[name] || FileText;
  return <IconComponent className={className} />;
}
